import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LAWYER_ROUTES } from "@/shared/constants/paths";

import LawyerSignupPage from "@/pages/lawyer/signup/LawyerSignupPage";
import LawyerVerifyPage from "@/pages/lawyer/signup/LawyerVerifyPage";
import LawyerProfilePage from "@/pages/lawyer/signup/LawyerProfilePage";
import LawyerLoginPage from "@/pages/lawyer/login/LawyerLoginPage";
import { LawyerDashboard as DashboardPage } from "@/pages/lawyer/dashboard/DashboardPage";
import ClientDetailPage from "@/pages/lawyer/client-detail/ClientDetailPage";
import { LawyerSettingsPage } from "@/pages/lawyer/settings/LawyerSettingsPage";

export const lawyerAuthRoutes = (
  <>
    <Route
      path={LAWYER_ROUTES.SIGNUP}
      element={
        <>
          <Helmet>
            <title>Attorney Registration - Elayne</title>
          </Helmet>
          <LawyerSignupPage />
        </>
      }
    />
    <Route
      path={LAWYER_ROUTES.SIGNUP_VERIFY}
      element={
        <>
          <Helmet>
            <title>Verify Email - Elayne</title>
          </Helmet>
          <LawyerVerifyPage />
        </>
      }
    />
    <Route
      path={LAWYER_ROUTES.SIGNUP_PROFILE}
      element={
        <>
          <Helmet>
            <title>Set Up Profile - Elayne</title>
          </Helmet>
          <LawyerProfilePage />
        </>
      }
    />
    <Route
      path={LAWYER_ROUTES.LOGIN}
      element={
        <>
          <Helmet>
            <title>Attorney Login - Elayne</title>
          </Helmet>
          <LawyerLoginPage />
        </>
      }
    />
  </>
);

export const lawyerProtectedRoutes = (
  <>
    <Route
      path={LAWYER_ROUTES.DASHBOARD}
      element={
        <>
          <Helmet>
            <title>Legal Dashboard - Elayne</title>
          </Helmet>
          <DashboardPage />
        </>
      }
    />
    <Route
      path={LAWYER_ROUTES.CLIENT_DETAIL}
      element={
        <>
          <Helmet>
            <title>Client Detail - Elayne</title>
          </Helmet>
          <ClientDetailPage />
        </>
      }
    />
    <Route
      path={LAWYER_ROUTES.SETTINGS}
      element={
        <>
          <Helmet>
            <title>Settings - Elayne</title>
          </Helmet>
          <LawyerSettingsPage />
        </>
      }
    />
  </>
);
